import React from 'react';
import Navbar from '../components/navbar';


export default function About() {
  return (
    <>
    <Navbar/>
    <div className="about_container">
    <nav aria-label="breadcrumb">
  <ol className="breadcrumb">
    <li className="breadcrumb-item " aria-current="page">Home</li>
    <li className="breadcrumb-item active" aria-current="page">About</li>
  </ol>
</nav>
    </div>
    <div className='about_con container'>
      <div className='row'>
        <div className='col-lg-6 aboutcon'>
          <h1>About me</h1>
          <hr className='hrname'/>
          <p className='aboutp'>How will i help you...!</p>

        </div>
        <div className='col-lg-6 about_content'>
          <p>My name is <strong>Simran Khurana</strong>, and I hold a Bachelor's degree with a focus on <em>web development</em>. Currently, I learning more to further deepen my knowledge and skills in this field. As a front-end developer, I specialize in creating diverse and dynamic websites that are not only visually appealing but also highly responsive and user-friendly. With a strong foundation in HTML, CSS, JavaScript, and various frameworks like Bootstrap, I am adapt at transforming design concepts into interactive, high-performance websites. I am passionate about staying current with the latest industry trends and technologies I am committed to crafting a digital presence that not only looks stunning but also provides an exceptional user experience. By choosing to work with me, you can be confident in receiving a website that effectively represents your brand and enhances your online presence, driving both engagement and growth..</p>
        </div>
      </div>
    </div>

    </>
  )
}
